import React from "react";
import Slider from "react-slick";

const AppScreensSlider = () => {
    const width = window.innerWidth;

    const settings = {
        dots: false,
        infinite: true,
        speed: 1400,
        slidesToShow:
            width <= 768
                ? 1      // Mobile
                : width <= 1024
                    ? 2   // Tablet
                    : 3,  // Desktop
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        pauseOnHover: true,
        arrows: false,
        centerMode: true,
        centerPadding: "0px",
        swipeToSlide: true,
    };

    const screens = [
        {
            title: "Food Delivery",
            image:
                "https://images.unsplash.com/photo-1551650975-87deedd944c3?q=80&w=1200&auto=format&fit=crop",
        },
        {
            title: "Fitness Tracker",
            image:
                "https://images.unsplash.com/photo-1576678927484-cc907957088c?q=80&w=1200&auto=format&fit=crop",
        },
        {
            title: "Finance App",
            image:
                "https://images.unsplash.com/photo-1559526324-593bc073d938?q=80&w=1200&auto=format&fit=crop",
        },

        {
            title: "Healthcare",
            image:
                "https://images.unsplash.com/photo-1580281657527-47f249e8f4df?q=80&w=1200&auto=format&fit=crop",
        },
    ];

    return (
        <>
            <section
                style={{
                    padding: "110px 0",
                    background:
                        "linear-gradient(180deg,#ffffff 0%,#fff7f7 50%,#ffffff 100%)",
                    overflow: "hidden",
                    position: "relative",
                }}
            >
                {/* Background Glow */}
                <div
                    style={{
                        position: "absolute",
                        width: "500px",
                        height: "500px",
                        borderRadius: "50%",
                        background: "rgba(232,33,42,.08)",
                        filter: "blur(120px)",
                        top: "-150px",
                        left: "-120px",
                    }}
                />

                <div
                    style={{
                        maxWidth: "1440px",
                        margin: "0 auto",
                        padding: "0 20px",
                        position: "relative",
                        zIndex: 2,
                        overflow: "hidden",
                    }}
                >
                    {/* Heading */}
                    <div
                        style={{
                            textAlign: "center",
                            marginBottom: "70px",
                            animation: "fadeUp 1s ease",
                        }}
                    >
                        <span
                            style={{
                                display: "inline-block",
                                padding: "10px 18px",
                                borderRadius: "999px",
                                background: "rgba(232,33,42,.08)",
                                color: "#E8212A",
                                fontWeight: "700",
                                fontSize: "14px",
                                fontFamily:
                                    "'Plus Jakarta Sans', sans-serif",
                                marginBottom: "20px",
                            }}
                        >
                            APP SCREENS
                        </span>

                        <h2
                            style={{
                                fontSize: "58px",
                                lineHeight: "1.1",
                                color: "#111",
                                marginBottom: "18px",
                                fontFamily: "'Syne', sans-serif",
                                textAlign: "center",
                            }}
                        >
                            Beautiful Mobile<br />
                            <span style={{ color: "#E8212A" }}>
                                {" "}
                                App Interfaces
                            </span>
                        </h2>

                        <p
                            style={{
                                maxWidth: "760px",
                                margin: "0 auto",
                                color: "#666",
                                fontSize: "18px",
                                lineHeight: "1.8",
                                fontFamily:
                                    "'Plus Jakarta Sans', sans-serif",
                                textAlign: "center"
                            }}
                        >
                            We craft modern, smooth and engaging mobile app
                            experiences with premium UI/UX design and
                            high-performance interactions.
                        </p>
                    </div>

                    {/* Slider */}
                    <div
                        style={{
                            width: "100%",
                            overflow: "hidden",
                        }}
                    >
                        <Slider {...settings}>
                            {screens.map((item, index) => (
                                <div key={index}>
                                    <div
                                        className="screen-card"
                                        style={{
                                            padding: "0 14px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: "relative",
                                                borderRadius: "36px",
                                                overflow: "hidden",
                                                background: "#fff",
                                                padding: "14px",
                                                boxShadow:
                                                    "0 20px 60px rgba(0,0,0,.08)",
                                                transition: ".5s ease",
                                            }}
                                        >
                                            {/* Phone Frame */}
                                            <div
                                                style={{
                                                    background: "#111",
                                                    borderRadius: "30px",
                                                    padding: "10px",
                                                    position: "relative",
                                                }}
                                            >
                                                {/* Notch */}
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "12px",
                                                        left: "50%",
                                                        transform:
                                                            "translateX(-50%)",
                                                        width: "80px",
                                                        height: "18px",
                                                        background: "#000",
                                                        borderRadius: "20px",
                                                        zIndex: 5,
                                                    }}
                                                />

                                                <img
                                                    src={item.image}
                                                    alt=""
                                                    className="screen-image"
                                                    style={{
                                                        width: "100%",
                                                        height: "650px",
                                                        objectFit: "cover",
                                                        borderRadius: "24px",
                                                        transition: "1.2s ease",
                                                    }}
                                                />
                                            </div>

                                            {/* Floating Info */}
                                            <div
                                                className="floating-info"
                                                style={{
                                                    position: "absolute",
                                                    left: "50%",
                                                    bottom: "24px",
                                                    transform:
                                                        "translateX(-50%)",
                                                    width: "85%",
                                                    background:
                                                        "rgba(255,255,255,.92)",
                                                    backdropFilter: "blur(16px)",
                                                    border:
                                                        "1px solid rgba(255,255,255,.4)",
                                                    borderRadius: "22px",
                                                    padding: "18px",
                                                    transition: ".5s ease",
                                                    boxShadow:
                                                        "0 10px 30px rgba(0,0,0,.08)",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div>
                                                        <h3
                                                            style={{
                                                                fontSize: "24px",
                                                                marginBottom: "6px",
                                                                color: "#111",
                                                                fontWeight: "800",
                                                                fontFamily:
                                                                    "'Syne', sans-serif",
                                                            }}
                                                        >
                                                            {item.title}
                                                        </h3>

                                                        <p
                                                            style={{
                                                                color: "#666",
                                                                fontSize: "14px",
                                                                lineHeight: "1.6",
                                                                fontFamily:
                                                                    "'Plus Jakarta Sans', sans-serif",
                                                            }}
                                                        >
                                                            Premium mobile app UI
                                                            experience.
                                                        </p>
                                                    </div>

                                                    <div
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "16px",
                                                            background:
                                                                "linear-gradient(135deg,#E8212A,#ff4d5a)",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent:
                                                                "center",
                                                            color: "#fff",
                                                            fontSize: "20px",
                                                            boxShadow:
                                                                "0 12px 30px rgba(232,33,42,.3)",
                                                        }}
                                                    >
                                                        ↗
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>

                {/* CSS */}
                <style>{`

                    .slick-slider{
                        width:100%;
                        overflow:hidden;
                    }

                    .slick-list{
                        overflow:hidden !important;
                        margin:0 -10px;
                    }

                    .slick-track{
                        display:flex !important;
                        align-items:center;
                    }

                    .slick-slide{
                        opacity:.55;
                        transform:scale(.88);
                        transition:all .7s ease;
                    }

                    .slick-slide > div{
                        margin:0 10px;
                    }

                    .slick-center{
                        opacity:1 !important;
                        transform:scale(1) !important;
                    }

                    .screen-card{
                        transition:.5s ease;
                    }

                    .screen-card:hover .screen-image{
                        transform:scale(1.06);
                    }

                    .screen-card:hover{
                        transform:translateY(-10px);
                    }

                    .screen-card:hover .floating-info{
                        bottom:32px !important;
                    }

                    @keyframes fadeUp{
                        from{
                            opacity:0;
                            transform:translateY(60px);
                        }
                        to{
                            opacity:1;
                            transform:translateY(0);
                        }
                    }

                    @media(max-width:992px){

                        .slick-slide{
                            opacity:1 !important;
                            transform:scale(1) !important;
                        }

                    }

                    @media(max-width:768px){

                        section{
                            padding:40px 20px !important;
                        }

                        h2{
                            font-size:38px !important;
                        }

                        .screen-image{
                            height:520px !important;
                        }

                        .screen-card{
                            padding:0 !important;
                        }

                        .slick-slide > div{
                            margin:0;
                        }

                    }

                `}</style>
            </section>
        </>
    );
};

export default AppScreensSlider;